import { getFullLegalName } from "../Profiles/utils";
import { FatcaCrsRowItem, TaxReportingDataItem, TaxReportingMetaData } from "./types";

const TAX_TYPE_PREFIX = {
  FATCA: "fatca_",
  CRS: "crs_",
} as const;

const ROLE_DISPLAY_MAP: Record<string, string> = {
  fatca_substantial_owner: "FATCA substantial owner",
  crs_controlling_person: "CRS controlling person",
};

export const isFatcaType = (taxReportingType: string): boolean =>
  taxReportingType.startsWith(TAX_TYPE_PREFIX.FATCA);

export const isCrsType = (taxReportingType: string): boolean =>
  taxReportingType.startsWith(TAX_TYPE_PREFIX.CRS);

export const formatRole = (taxReportingType: string): string =>
  ROLE_DISPLAY_MAP[taxReportingType] ?? taxReportingType.replace(/_/g, " ");

const getStringOrNull = (value: unknown): string | null =>
  typeof value === "string" ? value : null;

export const getProfileName = (metaData: TaxReportingMetaData | null): string => {
  if (!metaData) return "--";

  return getFullLegalName(
    getStringOrNull(metaData.first_name),
    getStringOrNull(metaData.last_name),
    getStringOrNull(metaData.middle_name),
  );
};

export const transformToRowData = (
  taxReportingData: TaxReportingDataItem[],
): FatcaCrsRowItem[] =>
  taxReportingData
    .filter((item) => item.assigned === true)
    .map((item) => ({
      id: item.id,
      profileName: getProfileName(item.metaData),
      role: formatRole(item.taxReportingType),
      documentId: item.documentId,
      taxReportingType: item.taxReportingType,
      isFatca: isFatcaType(item.taxReportingType),
      isCrs: isCrsType(item.taxReportingType),
    }));
